import { observer } from 'mobx-react-lite'
import { Divider, Label, SpinnerLoader } from 'shared/ui'
import { type ConversationAssignmentStore } from 'pages/settings/pages/inboxes/pages/id/pages/settings/messaging/conversationAssignment/store/conversationAssignmentStore'
import { DoubleOptInSettingLayout } from 'pages/settings/pages/doubleOptIn/ui/doubleOptInSetting/DoubleOptInSettingLayout'
import styles from './styles.module.scss'
import { ManualAssignmentUserSelect } from './ManualAssignmentUserSelect/ManualAssignmentUserSelect'
import { SentimentAssignment } from './SentimentAssignment/SentimentAssignment'

export const ManualConversationAssignment = observer(
  ({ store }: { store: ConversationAssignmentStore }) => {
    const {
      filteredMembers,
      searchValue,
      setSearchValue,
      selectedManualUserId,
      updateManualAssignment,
      membersLoading,
      selectedItem,
      smartAssignment,
      updateSmartAssignment,
    } = store

    if (membersLoading) {
      return <SpinnerLoader ariaLabel={'ManualConversationAssignment'} className={styles.spinner} />
    }

    return (
      <>
        <Label
          label={{
            text: 'All new conversation will be assigned to',
          }}
          marginBottom={4}
        />
        <ManualAssignmentUserSelect
          setValue={updateManualAssignment}
          value={selectedManualUserId}
          items={filteredMembers}
          search={searchValue}
          onSearch={setSearchValue}
          selectedItem={selectedItem}
        />
        <Divider style={{ marginTop: '24px', marginBottom: '7px' }} />

        <DoubleOptInSettingLayout
          title={'Smart Assignment'}
          description={'Assign conversation based on sentiment'}
          checked={smartAssignment}
          onToggle={updateSmartAssignment}
        />

        {smartAssignment && (
          <div className={styles.sentimentContainer}>
            <SentimentAssignment
              store={store}
              title='Positive'
              description='Positive sentiment refers to a feeling or attitude that is characterized by optimism, happiness'
              sentimentField='smart_assignment_positive'
            />
            <SentimentAssignment
              store={store}
              title='Neutral'
              description='Neutral sentiment refers to a lack of emotion or attitude towards a particular topic'
              sentimentField='smart_assignment_neutral'
            />
            <SentimentAssignment
              store={store}
              title='Negative'
              description='Negative sentiment refers to a feeling or attitude that is characterized by pessimism, sadness, anger, frustration'
              sentimentField='smart_assignment_negative'
            />
          </div>
        )}
      </>
    )
  }
)
